import { IDongBoCongNoRequest } from "../../model/request/dong-bo/IDongBoCongNoRequest";
import { IDongBoHocPhiRequest } from "../../model/request/dong-bo/IDongBoHocPhiRequest";
import { IDongBoPhiKyTucXaRequest } from "../../model/request/dong-bo/IDongBoPhiKyTucXaRequest";
import { IProcessRequest } from "../../model/request/IProcessRequest";
import { IDongBoPhiKyTucXaSinhVien } from "../../model/respone/dong-bo/IDongBoPhiKyTucXaSinhVien";
import { apiClient } from "../apiClient";

export const DONG_BO_ENDPOINT = "dong-bo";

export const dongBoApi = {
  SelectHocPhi: (request: IDongBoHocPhiRequest) =>
    apiClient.post(`${DONG_BO_ENDPOINT}/hoc-phi/select-sinh-viens`, request),
  SyncHocPhi: (request: IProcessRequest<IDongBoHocPhiRequest>) =>
    apiClient.post(
      `${DONG_BO_ENDPOINT}/hoc-phi/sync?process_id=${request.process_id}`,
      request.payload
    ),

  SelectPhiKyTucXa: (request: IDongBoPhiKyTucXaRequest) =>
    apiClient.get(
      `https://qlkytucxa.hvtc.edu.vn/api/get-tien-phong/hoc-ky/${request.hoc_ky}/nam-hoc/${request.nam_hoc}`
    ),
  // apiClient.post(
  //   `${DONG_BO_ENDPOINT}/phi-ky-tuc-xa/select-sinh-viens`,
  //   request
  // ),
  SyncKyTucXa: (request: IProcessRequest<IDongBoPhiKyTucXaSinhVien[]>) =>
    apiClient.post(
      `${DONG_BO_ENDPOINT}/ky-tuc-xa/sync?process_id=${request.process_id}`,
      request.payload
    ),

  SelectCongNo: (request: IDongBoCongNoRequest) =>
    apiClient.post(`${DONG_BO_ENDPOINT}/cong-no/select-sinh-viens`, request),
  SyncCongNo: (request: IProcessRequest<IDongBoCongNoRequest>) =>
    apiClient.post(
      `${DONG_BO_ENDPOINT}/cong-no/sync?process_id=${request.process_id}`,
      request.payload
    ),
};
